import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=01c7c071&scoped=true"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"
import style0 from "./Search.vue?vue&type=style&index=0&id=01c7c071&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c7c071",
  null
  
)

export default component.exports